<div class="container" [ngClass]="{ 'in-dialog': isInDialog }">
    <form [formGroup]="profileForm" class="form-container">
        <div class="input-field">
            <label for="name" class="required">{{ "profileDetails.label.name" | translate }}</label>
            <input
                id="name"
                type="text"
                formControlName="name"
                class="profile-input"
                [placeholder]="'profileDetails.placeholder.name' | translate"
                maxlength="50"
                required
            />
            <div *ngIf="isInvalid('name')">
                <div *ngIf="isInvalid('name', 'required')" class="text-red">
                    {{ "profileDetails.label.name" | translate }}
                    {{ "profileDetails.invalidMessage.mandatory" | translate }}
                </div>
                <div *ngIf="isInvalid('name', 'forbiddenName')" class="text-red">
                    {{ "profileDetails.label.name" | translate }}
                    {{ "profileDetails.invalidMessage.numberSpecialInvalid" | translate }}
                </div>
            </div>
        </div>

        <div class="input-field">
            <label for="email" class="required">{{ "profileDetails.label.email" | translate }}</label>
            <input
                id="email"
                type="text"
                formControlName="email"
                class="profile-input"
                [placeholder]="'profileDetails.placeholder.email' | translate"
                required
            />
            <div *ngIf="isInvalid('email')">
                <div *ngIf="isInvalid('email', 'required')" class="text-red">
                    {{ "profileDetails.label.email" | translate }}
                    {{ "profileDetails.invalidMessage.mandatory" | translate }}
                </div>
                <div *ngIf="isInvalid('email', 'invalidEmail') && !isInvalid('email', 'required')" class="text-red">
                    {{ "profileDetails.invalidMessage.emailInvalid" | translate }}
                </div>
            </div>
        </div>
        <div class="input-field age-field" *ngIf="!hideAgeAndShowMobile">
            <label for="age" class="required">{{ "profileDetails.label.age" | translate }}</label>
            <input
                id="age"
                type="text"
                formControlName="age"
                class="profile-input"
                [placeholder]="'profileDetails.placeholder.age' | translate"
                (keypress)="onValidNumber($event)"
                required
            />
            <div *ngIf="isInvalid('age')">
                <div *ngIf="isInvalid('age', 'required')" class="text-red">
                    {{ "profileDetails.label.age" | translate }}
                    {{ "profileDetails.invalidMessage.mandatory" | translate }}
                </div>
            </div>
        </div>

        <div class="input-field" *ngIf="hideAgeAndShowMobile">
            <label for="userMobileNumber" class="required">{{ "profileDetails.label.phoneNo" | translate }}</label>
            <input
                id="userMobileNumber"
                type="text"
                class="profile-input"
                formControlName="userMobileNumber"
                (keypress)="onValidNumber($event)"
                [placeholder]="'profileDetails.placeholder.phoneNo' | translate"
                maxlength="10"
                minlength="10"
            />
            <div *ngIf="isInvalid('userMobileNumber')">
                <div *ngIf="isInvalid('userMobileNumber', 'required')" class="text-red">
                    {{ "profileDetails.label.phoneNo" | translate }}
                    {{ "profileDetails.invalidMessage.mandatory" | translate }}
                </div>
                <div *ngIf="isInvalid('userMobileNumber', 'minlength')" class="text-red">
                    {{ "profileDetails.invalidMessage.mobileNoInvalid" | translate }}
                </div>
            </div>
        </div>
    </form>
</div>
